import styles from "./FiltersInstitution.module.scss";
import { 
  ShadcnAutoCompleteSearch, 
  ShadcnSelectListFilters 
} from "Explore/Components";
import { getSuggestSearchInstitutions } from "Explore/Services/Institution";
import {
  classification_select,
  school_type_select,
  state_select,
} from "Explore/Config/FilterData";
import { ParamsFilterKey } from "Config/filterSearchParams";
import useFilterAndPagination from "Hooks/useFilterAndPagination";

import { RotateCcw } from "lucide-react";

const FiltersInstitution = ({
  filter: filterProps,
  updateFilter: updateFilterProps,
}) => {
  const { filter: _filter, updateSearchParams: _updateSearchParams, resetFilter } =
    useFilterAndPagination();
  const filter = filterProps || _filter;
  const updateFilter = updateFilterProps || _updateSearchParams;
  
  return (
    <div className="flex flex-col gap-8 p-6 bg-white rounded-lg shadow-sm border border-gray-100 h-fit xl:sticky xl:top-[90px] xl:max-h-[calc(100vh-100px)] xl:overflow-y-auto xl:mt-[96px] w-full xl:max-w-[300px]">
      
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider">Filters</h3>
        <button
          onClick={resetFilter}
          className="text-xs text-gray-400 hover:text-gray-700 flex items-center gap-1.5 transition-colors"
        >
          <RotateCcw size={12} />
          Clear filters
        </button>
      </div>
      
      {/* Institution */}
      <div className="flex flex-col gap-3">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Institution
        </label>
        <ShadcnAutoCompleteSearch
          placeholder={"Search by institution"}
          functionSearch={getSuggestSearchInstitutions}
          filters={filter}
          setFilters={updateFilter}
          entity={ParamsFilterKey.QUERY}
        />
      </div>

      {/* Classification */}
      <div className="flex flex-col gap-3">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          Classification
        </label>
        <ShadcnSelectListFilters
          placeholder={"Choose a classification"}
          options={classification_select}
          filters={filter}
          setFilters={updateFilter}
          entity={ParamsFilterKey.CLASSIFICATIONS}
        />
      </div>

      {/* State */}
      <div className="flex flex-col gap-3">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          State
        </label>
        <ShadcnSelectListFilters
          placeholder={"Choose a state"}
          options={state_select}
          filters={filter}
          setFilters={updateFilter}
          entity={ParamsFilterKey.STATES}
        />
      </div>

      {/* School type */}
      <div className="flex flex-col gap-3">
        <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">
          School type
        </label>
        <ShadcnSelectListFilters
          placeholder={"Choose a type"}
          options={school_type_select}
          filters={filter}
          setFilters={updateFilter}
          entity={ParamsFilterKey.SCHOOL_TYPE}
        />
      </div>
      
    </div>
  );
};

export default FiltersInstitution;
